<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <!-- <el-form-item>
        <el-button
          :loading="downloadLoading"
          style="margin: 0 0 10px 0px"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
          >导出 Excel（数量/ {{ dataList.length }}条）</el-button
        >
      </el-form-item> -->

      <el-form-item
        label="用户名称: "
        style="margin-left:20px"
        v-if="roleId != 1 && roleId != 2 && roleId != 3"
      >
        <el-input
          v-model="selectForm.sup_username"
          placeholder="请输入"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="手机号: " style="margin-left:20px">
        <el-input
          v-model="phone"
          placeholder="请输入手机号"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item> -->
      <el-form-item label="审核状态: ">
        <el-select
          v-model="selectForm.cashStatus"
          placeholder="请选择"
          clearable
        >
          <div v-for="item in statusList" :key="item.id">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="用户ID: " style="margin-left:20px">
        <el-input
          v-model="userId"
          placeholder="请输入用户id"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>  -->
      <el-form-item>
        <el-button type="primary" @click="selectBtn">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height:75%">
      <el-table
        border
        :data="dataList"
        style="width: 100%;overflow-y: scroll;"
        height="calc(100vh - 220px)"
        v-loading="loading"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="订单类型" align="center" width="130">
          <template slot-scope="scope">
            <el-tag size="medium">{{
              scope.row.orderType == 1
                ? "商品订单"
                : scope.row.orderType == 2
                ? "检测订单"
                : scope.row.orderType == 3
                ? "医生推荐用药订单"
                : "-"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="收款用户名称" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.sup_username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="下单客户ID" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.userId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="下单客户手机号" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="佣金" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.money ? scope.row.money : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="佣金审核状态" align="center" width="180">
          <template slot-scope="scope">
            <span style="color:red">{{
              scope.row.cashStatus == 0
                ? "审核中"
                : scope.row.cashStatus == 1
                ? "已通过"
                : scope.row.cashStatus == 2
                ? "驳回"
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="180" align="center">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p style="text-align:center">
                <span style="color:red;font-weight:600">{{
                  scope.row.message
                }}</span>
              </p>
              <div slot="reference" class="name-wrapper addressDetail">
                {{ scope.row.message ? scope.row.message : "-" }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="200" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="220"
          align="center"
          v-if="roleId != 1 && roleId != 2 && roleId != 3"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="shenhe(scope.row)"
              >审核</el-button
            >
            <el-button size="mini" type="danger" @click="deleteBtn(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 发货 -->
    <el-dialog
      title="审核"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="佣金审核状态: ">
          <el-select v-model="form.cashStatus" placeholder="请选择" clearable>
            <div v-for="item in statusList" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="发放金额">
          <el-input v-model="form.money" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="form.message"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleUpdate">确定</el-button>
      </div>
    </el-dialog>

    <!--  -->
    <el-dialog
      title="订单详情"
      :visible.sync="dialogFormVisible2"
      :close-on-click-modal="false"
    >
      <el-table
        :data="orderDetailArr"
        style="width: 100%;overflow-y: scroll;"
        height="400px"
        v-loading="loading"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="订单号" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.orderNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="商品id"
          align="center"
          prop="id"
        ></el-table-column>
        <el-table-column
          label="商品名"
          width="280"
          align="center"
          prop="productName"
        ></el-table-column>
        <el-table-column
          label="数量"
          align="center"
          prop="num"
        ></el-table-column>
        <el-table-column
          label="单价"
          align="center"
          prop="price"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectList,
  deleteMoney,
  updateOrder,
} from "@/services/marketing/bonus";
import XLSX from "xlsx";
export default {
  data() {
    return {
      downloadLoading: false,
      dataList: [],
      orderDetailArr: [],
      loading: true,
      name: "",
      orderNumber: "",
      phone: "",
      userId: "",
      form: {
        logisticsNumber: "",
      },
      pageCount: "",
      pageSize: 8,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      isRole: false,
      statusList: [
        { id: 0, name: "审核中" },
        { id: 1, name: "已通过" },
        { id: 2, name: "驳回" },
      ],
      selectForm: {}, //查询条件
      roleId: "",
    };
  },
  created() {
    if (
      this.$store.state.supUser.roleId == 1 ||
      this.$store.state.supUser.roleId == 2||
      this.$store.state.supUser.roleId == 3 //医生
    ) {
      this.selectForm.adminId = this.$store.state.supUser.id;
      this.roleId = this.$store.state.supUser.roleId;
    }

    this.select();
  },
  methods: {
    select() {
      console.log(this.selectForm);
      // 查询订单数据
      selectList({ ...this.selectForm }).then((resp) => {

        this.dataList = resp.data;
        this.loading = false;
      });
    },

    selectBtn() {
      this.select();
    },

    // 审核弹窗
    shenhe(row) {
      
      this.dialogFormVisible = true;
      this.form = JSON.parse(JSON.stringify(row));
    },

    // 确认修改
    handleUpdate() {
      if (!this.form.cashStatus || !this.form.money || !this.form.message) {
        this.$message.error("请填写信息");
        return;
      }
      updateOrder({
        ...this.form,
      }).then((res) => {
 
        this.dialogFormVisible = false;
        this.$message.success("操作成功");
        this.select();
      });
    },
    deleteBtn(row) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // console.log(row.id);
          deleteMoney({ id: row.id }).then((resp) => {
    
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../../vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "id",
          "订单号",
          "姓名",
          "手机号",
          "收货地址",
          "留言",
          "订单总价",
          "物流单号",
          "佣金审核状态(0未发货 1已发货 2已完成 3退款中 4已退款)",
          "商品明细",
          "下单时间",
        ];
        const filterVal = [
          "id",
          "orderNumber",
          "name",
          "phone",
          "address",
          "odescribe",
          "cost",
          "logisticsNumber",
          "status",
          "productList",
          "createTime",
        ];
        const dataList = JSON.parse(JSON.stringify(this.dataList));
        const list = dataList.map((item) => {
          const product = item.productList.map((item2) => {
            return `${item2.productName}(${item2.price}元)X${item2.num}`;
          });
          item.productList = JSON.parse(JSON.stringify(product));
          return {
            ...item,
            productList: item.productList.join(","),
          };
        });
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "订单列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx", //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
  },
};
</script>

<style scoped>
.content {
  margin: 10px auto;
  width: 98%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.addressDetail {
  width: 140px;
  margin: 0 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.addressDetail:hover {
  cursor: pointer;
}
</style>
